import { memo, useEffect, useState } from "react";
import { useLocation } from "../router.js";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { ThirdBackgroundButton } from "#components";
import { CheckCircle, Error } from "@mui/icons-material";

const useStyles = makeStyles(() => ({
	page: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		minHeight: "calc(100vh - 90px)",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "50px",
	},
	box: {
		display: "flex",
		flexDirection: "column",
		width: "500px",
		height: "100%",
		padding: "20px",
	},
	button: {
		marginLeft: "auto",
		marginRight: "auto",
	}
}));

const CheckoutResult = ({ result = "success" }) => {
	const classes = useStyles();
	const search = useLocation().search;
	const [transactionId, setTransactionId] = useState("");
	const [sessionId, setSessionId] = useState("");

	useEffect(() => {
		setTransactionId(new URLSearchParams(search).get("transactionId"));
		setSessionId(new URLSearchParams(search).get("sessionId"));
	}, [search]);

	return (
		<Grid className={classes.page}>
			{result === "success" && (
				<Grid item className={classes.box}>
					<CheckCircle color="success" fontSize="inherit" />
					<Typography fontWeight="bold" fontSize="20px">
						{"Payment successful!"}
					</Typography>
					<Typography fontSize="18px" mt={2}>
						{"Your order has been placed. We'll send you an email with your order details."}
					</Typography>
					<Typography fontSize="18px" mt={2}>
						{"In order to activate your purchase, navigate to configurator and enter the following licence key:"}
					</Typography>
					<Typography fontSize="18px" fontWeight="bold" mt={2} mb={2} textAlign="center">
						{transactionId}
					</Typography>
					<ThirdBackgroundButton
						id="navigate-configurator"
						title="Go to Configurator"
						width="200px"
						className={classes.button}
						onClick={() => { window.location.href = "https://configurator.cyclopt.com"; }}
					/>
				</Grid>
			)}
			{result === "failure" && (
				<Grid item className={classes.box}>
					<Error color="error" fontSize="inherit" />
					<Typography fontWeight="bold" fontSize="20px">
						{"Activation failed!"}
					</Typography>
					<Typography fontSize="18px" mt={2}>
						{"While the transaction was successful, we were unable to generate your invoice or receipt details."}
					</Typography>
					<Typography fontSize="18px" mt={2}>
						{"There is no need to worry, we 'll contact you shortly to resolve the issue. You can also contact us using the following session ID:"}
					</Typography>
					<Typography fontSize="18px" fontWeight="bold" mt={2} mb={2} textAlign="center">
						{sessionId}
					</Typography>
					<ThirdBackgroundButton
						id="navigate-configurator"
						title="Contact us"
						width="200px"
						className={classes.button}
						onClick={() => { window.location.href = "https://cyclopt.com/contact"; }}
					/>
				</Grid>
			)}
		</Grid>

	);
};

export default memo(CheckoutResult);
